import { defaultColumns } from './default-columns';
import { importReviewPiesColumns } from './import-review-pies-columns';
import { importReviewAcesColumns } from './import-review-aces-columns';
import { exportReviewColumns } from './export-review-columns';
import { availableColumnsList } from './available-columns';


export const columns: any = {
  'import-review-pies': importReviewPiesColumns,
  'import-review-aces': importReviewAcesColumns,
  'import-review-custom-fields': importReviewPiesColumns,
  'working': defaultColumns,
  'published': defaultColumns,
  'export-review': exportReviewColumns,
  'view-export': defaultColumns,
};

export const availableColumns: any = {
  'working': availableColumnsList,
  'published': availableColumnsList,
  'view-export': availableColumnsList,
};
